export const getTeacherName = (teachersForStudent, id, behaviorData, user) => {
  if (!id) return 'Unknown';


  if (behaviorData?.info?.BehaviorDetails?.BehaviorAuthor === user?.uid) {
    return user?.fullname || user?.name || user?.displayName || 'Unknown';
  }

  if (behaviorData?.info?.StudentID === id) {
    return behaviorData?.info?.StudentName || behaviorData?.StudentName || 'Unknown';
  }

  if (!Array.isArray(teachersForStudent)) return 'Unknown';
  const teacher = teachersForStudent.find((t) => t.uid === id);
  return teacher?.info?.fullname || 'Unknown';
};

export const getValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return 'Not specified';
  }
  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(', ') : 'Not specified';
  }
  return value;
};

